var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import { useVirtualizedApp } from "../../Hooks/useVirtualizedApp";
import CampaignService from "../../../Services/Campaign.service";
import EnrollOpportunitiesInCampaignForm from "./EnrollOpportunitiesInCampaignForm";
import ShowMoreList, { StringShowMoreListRenderer, } from "../../UI/ShowMoreList/ShowMoreList";
import useUniqueId from "../../Hooks/useUniqueId";
import { MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL } from "../../Container/Pipeline/PipelineDetailListMenu";
const EnrollOpportunitiesInCampaignModal = (_a) => {
    var { opportunities, singular } = _a, modalProps = __rest(_a, ["opportunities", "singular"]);
    const virtualizedAppContext = useVirtualizedApp();
    const opportunityString = singular ? "Opportunity" : "Opportunities";
    const makeId = useUniqueId()[1];
    return (_jsxs(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Enroll " + opportunityString + " in Campaign", handleSubmit: (state) => CampaignService.enrollOpportunitiesInCampaign(opportunities.map(({ id }) => id), state.campaign.id), confirmSubmit: `Are you sure you want to enroll ${opportunities.length === 1
            ? "1 Opportunity"
            : `${opportunities.length} Opportunities`} in this campaign?`, children: [_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: makeId("opportunities"), children: [opportunityString, " ", !singular && `(${opportunities.length})`] }), _jsx("div", { id: makeId("opportunities"), children: _jsx(ShowMoreList, { numOfItemsToPreview: MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL, renderer: StringShowMoreListRenderer, items: opportunities.map((o) => o === null || o === void 0 ? void 0 : o.subject.fullName) }) })] }), _jsx(EnrollOpportunitiesInCampaignForm, { virtualizedAppName: virtualizedAppContext.name })] })));
};
export default EnrollOpportunitiesInCampaignModal;
